/** Gregorian calendar helpers for locale-aware date picker (en / ar). */

export function getDaysInGregorianMonth(year: number, month: number): number {
  return new Date(year, month, 0).getDate();
}

export function todayGregorian(): { year: number; month: number; day: number } {
  const n = new Date();
  return { year: n.getFullYear(), month: n.getMonth() + 1, day: n.getDate() };
}

export function shiftGregorianMonth(year: number, month: number, offset: number) {
  let m = month + offset;
  let y = year;
  while (m <= 0) {
    m += 12;
    y -= 1;
  }
  while (m > 12) {
    m -= 12;
    y += 1;
  }
  return { year: y, month: m };
}

/** First column index for month grid (0 = week start column). */
export function gregorianMonthPad(year: number, month: number, weekStartsOn: number): number {
  const dow = new Date(year, month - 1, 1).getDay();
  return (dow - weekStartsOn + 7) % 7;
}

export function gregorianWeekStartsOn(localeCode: string): number {
  return localeCode === 'ar' ? 6 : 0;
}

export const WEEKDAY_SHORT_EN = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
export const WEEKDAY_SHORT_AR = ['س', 'ح', 'ن', 'ث', 'ر', 'خ', 'ج'];

export function weekdayLabelsForGregorian(localeCode: string): string[] {
  const start = gregorianWeekStartsOn(localeCode);
  const base = localeCode === 'ar' ? WEEKDAY_SHORT_AR : WEEKDAY_SHORT_EN;
  return Array.from({ length: 7 }, (_, i) => base[(start + i) % 7] ?? '');
}

export function formatGregorianMonthYear(
  year: number,
  month: number,
  localeCode: string,
): string {
  const d = new Date(year, month - 1, 1);
  const loc = localeCode === 'ar' ? 'ar' : 'en';
  const monthName = new Intl.DateTimeFormat(loc, { month: 'long' }).format(d);
  return `${monthName} ${year}`;
}
